<template>
  <div class="footer-container">
    <footer>
      <div class="logo-container">
        <div class="logo-and-links">
          <div class="logo">
            <logo />
            <div class="app-description">{{ $t('app.description.short') }}</div>
          </div>
          <div class="links">
            <div class="links-column">
              <div v-a11y-tab:tab-line class="link">
                <router-link :to="paths.PROBLEMS" class="off-default-focus">{{ $t('problems') }}</router-link>
              </div>
              <div v-a11y-tab:tab-line class="link">
                <router-link :to="paths.REWARDS" class="off-default-focus">{{ $t('rewards') }}</router-link>
              </div>
              <div v-a11y-tab:tab-line class="link">
                <router-link :to="paths.PROMISES" class="off-default-focus">{{ $t('promises') }}</router-link>
              </div>
              <div v-a11y-tab:tab-line class="link">
                <router-link :to="paths.TARGETING" class="off-default-focus">{{ $t('targeting') }}</router-link>
              </div>
            </div>
            <div v-a11y-tab:tab-line class="link contact-us-laptop">
              <router-link :to="paths.CONTACTS" class="off-default-focus">{{ $t('contact') }}</router-link>
            </div>
            <div>
              <div v-a11y-tab:tab-line class="link contact-us-mobile">
                <router-link :to="paths.CONTACTS" class="off-default-focus">{{ $t('contact') }}</router-link>
              </div>
              <div class="links-column">
                <div v-a11y-tab:tab-line class="link">
                  <a :href="privacyPolicy" target="_blank">{{ $t('privacy.policy') }}</a>
                </div>
                <div v-a11y-tab:tab-line class="link">
                  <a :href="cookiePolicy" target="_blank">{{ $t('cookie.policy') }}</a>
                </div>
                <div v-a11y-tab:tab-line class="link">
                  <a :href="term" target="_blank">{{ $t('terms') }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rights">{{ $t('rights', { yearFrom, yearTo }) }}</div>
      </div>
      <div class="social">
        <social-icon class="social-item" name="fb"></social-icon>
        <social-icon class="social-item" name="in"></social-icon>
        <social-icon class="social-item" name="twi"></social-icon>
        <social-icon class="social-item" name="plus"></social-icon>
      </div>
    </footer>
  </div>
</template>

<script>
import Logo from '@/components/header/Logo.vue';
import SocialIcon from '@/components/footer/SocialIcon.vue';

import { ROUTER_PATHS } from '@/router/constants';
import { PDF } from '@/constants';

export default {
  components: {
    Logo,
    SocialIcon,
  },
  data() {
    return {
      yearFrom: 2019,
      privacyPolicy: PDF.PRIVACY_POLICY,
      cookiePolicy: PDF.COOKIE_POLICY,
      term: PDF.TERM,
    };
  },
  computed: {
    paths() {
      return ROUTER_PATHS;
    },
    yearTo() {
      return new Date().getUTCFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.footer-container {
  font-size: $font-size-base;
  min-height: $footer-height;
  background-color: $footer;
  display: flex;
  padding-top: 50px;
  justify-content: center;
}

.contact-us-mobile {
  display: none;
}

footer {
  width: $page-laptop-breakpoint;
  display: flex;
}

.logo-container {
  flex: 4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.logo-and-links {
  display: flex;
}

.logo {
  flex: 1;
  display: flex;
  flex-direction: column;
  color: $primary;
}

.app-description {
  margin: $base 0;
  width: 250px;
}

.links {
  flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.links-column {
  display: flex;
  flex-direction: column;
}

.link {
  margin: $base/2 0;
}

a {
  color: $text-d-grey;
}

.social-and-rights {
  display: flex;
  justify-content: space-between;
}

.rights {
  color: $text-grey;
  margin-top: $base;
}

.social {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  visibility: hidden;
}

.social-item {
  margin: $base/4;
}

@media (max-width: $page-laptop-breakpoint) {
  footer {
    max-width: $page-table-breakpoint;
  }

  .links {
    justify-content: space-between;
  }
}

@media (max-width: $page-table-breakpoint) {
  .logo-and-links,
  footer {
    max-width: $page-mobile-large-breakpoint;
    width: 100%;
    flex-direction: column;
    padding: 0 10px;
  }

  .contact-us-mobile {
    display: block;
  }

  .contact-us-laptop {
    display: none;
  }
}
</style>
